'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _AccordionWidget = require('../AccordionWidget');

var _AccordionWidget2 = _interopRequireDefault(_AccordionWidget);

var _Money = require('../../components/Money');

var _Money2 = _interopRequireDefault(_Money);

var _List = require('../../components/List');

var _List2 = _interopRequireDefault(_List);

var _Button = require('../../components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Skeleton = require('../../components/Skeleton');

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _Translate = require('../../components/Translate');

var _Translate2 = _interopRequireDefault(_Translate);

var _message = require('./message');

var _selectUnit = require('../../lib/utils/selectUnit');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HistoryWidgetList = function (_React$Component) {
  _inherits(HistoryWidgetList, _React$Component);

  function HistoryWidgetList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HistoryWidgetList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HistoryWidgetList.__proto__ || Object.getPrototypeOf(HistoryWidgetList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      page: 1
    }, _this.getFormattedDate = function (date) {
      return _react2.default.createElement(_reactIntl.FormattedDate, {
        value: date,
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }, _this.createListInfo = function (item, product, isLoading) {
      if (isLoading) return [[_react2.default.createElement(_Skeleton.SkeletonLine, { bold: true }), _react2.default.createElement(_Skeleton.SkeletonLine, null)], [_react2.default.createElement(_Skeleton.SkeletonLine, { bold: true }), _react2.default.createElement(_Skeleton.SkeletonLine, null)]];

      // Odds is missing currency, use user currency as a fallback.
      if (!item.Currency) item.Currency = _this.props.currency;

      if (product === 'casino') {
        return [[_react2.default.createElement(
          'div',
          null,
          item.Game
        ), _react2.default.createElement(
          'div',
          null,
          (0, _message.getMessage)((0, _get2.default)(item, 'Transactions[0].Status'))
        )], [_react2.default.createElement(_Money2.default, { value: item.Win - item.Bet, currency: item.Currency }), _react2.default.createElement(_reactIntl.FormattedRelativeTime, (0, _selectUnit.selectUnit)(new Date(item.StartTime + '+00:00')))]];
      } else if (product === 'sportsbook') {
        var selection = item.Transactions[0].Description;
        var odds = item.Transactions[0].Odds;
        var l = item.Transactions.filter(function (t) {
          return t.Odds > 0;
        }).length;

        return [[_react2.default.createElement(
          'div',
          null,
          selection + ' @ ' + odds + ' ' + (l > 1 ? '+' + (l - 1) : '')
        ), _react2.default.createElement(
          'div',
          null,
          (0, _message.getMessage)(item.Settled ? 'settled' : 'pendling')
        )], [_react2.default.createElement(_Money2.default, {
          value: item.TotalWin - item.TotalWager,
          currency: item.Currency
        }), _react2.default.createElement(_reactIntl.FormattedRelativeTime, (0, _selectUnit.selectUnit)(new Date(item.Created + '+00:00')))]];
      } else if (product === 'bingo') {
        return [[_react2.default.createElement(_Translate2.default, {
          tag: 'div'
          // We use a dynamic key here since we don't know rooms and new once can be added.
          , id: 'label.history.bingoroomid-' + item.RoomId
        }), _react2.default.createElement(
          'div',
          null,
          (0, _message.getMessage)((0, _get2.default)(item, 'Transactions[0].TransactionType'))
        )], [_react2.default.createElement(_Money2.default, {
          value: (0, _get2.default)(item, 'Transactions[0].Amount'),
          currency: item.Currency
        }), _react2.default.createElement(_reactIntl.FormattedRelativeTime, (0, _selectUnit.selectUnit)(new Date(item.Created + '+00:00')))]];
      } else if (product === 'fantasy') {
        return [[_react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Translate2.default, { id: 'label.history.fantasy-id', defaultMessage: 'Id' }),
          ' #',
          item.TournamentId
        ), _react2.default.createElement(
          'div',
          null,
          (0, _message.getMessage)(item.Status === 'Default' ? 'initiated' : item.Status === 'Canceled' ? 'canceled' : 'completed')
        )], [_react2.default.createElement(_Money2.default, {
          value: item.Win - (item.Bet + item.Rake),
          currency: item.Currency
        }), _react2.default.createElement(_reactIntl.FormattedRelativeTime, (0, _selectUnit.selectUnit)(new Date(item.Created + '+00:00')))]];
      }

      return [[_react2.default.createElement(
        'div',
        null,
        (0, _message.getMessage)(item.Method + item.TransactionType)
      ), _react2.default.createElement(
        'div',
        null,
        (0, _message.getMessage)(item.Status)
      )], [_react2.default.createElement(_Money2.default, {
        value: item.TransactionType === 'Withdraw' ? -item.Amount : item.Amount,
        currency: item.Currency
      }), _react2.default.createElement(_reactIntl.FormattedRelativeTime, (0, _selectUnit.selectUnit)(new Date(item.Started + '+00:00')))]];
    }, _this.createListDetail = function (item, product) {
      if (product === 'casino') {
        return [[_react2.default.createElement(
          'div',
          null,
          '#',
          item.RoundId
        ), _this.getFormattedDate(item.StartTime)], [_react2.default.createElement(_Translate2.default, {
          tag: 'div',
          id: 'label.history.bet',
          defaultMessage: 'Bet: {value}',
          values: {
            value: _react2.default.createElement(_Money2.default, { value: item.Bet, currency: item.Currency })
          }
        }), _react2.default.createElement(_Translate2.default, {
          tag: 'div',
          id: 'label.history.win',
          defaultMessage: 'Win: {value}',
          values: {
            value: _react2.default.createElement(_Money2.default, { value: item.Win, currency: item.Currency })
          }
        })]];
      } else if (product === 'sportsbook') {
        var bets = item.Transactions.filter(function (t) {
          return t.Odds > 0;
        }).map(function (t) {
          return t.Description + ' @ ' + t.Odds;
        });
        return [[_react2.default.createElement(
          'div',
          null,
          '#',
          item.Id
        ), _this.getFormattedDate(item.Created), _react2.default.createElement(
          'div',
          null,
          bets.map(function (b) {
            return _react2.default.createElement(
              'div',
              null,
              b
            );
          })
        )], [_react2.default.createElement(_Translate2.default, {
          tag: 'div',
          id: 'label.history.bet',
          defaultMessage: 'Bet: {value}',
          values: {
            value: _react2.default.createElement(_Money2.default, { value: item.TotalWager, currency: item.Currency })
          }
        }), _react2.default.createElement(_Translate2.default, {
          tag: 'div',
          id: 'label.history.win',
          defaultMessage: 'Win: {value}',
          values: {
            value: _react2.default.createElement(_Money2.default, { value: item.TotalWin, currency: item.Currency })
          }
        })]];
      } else if (product === 'bingo') {
        return [[_react2.default.createElement(
          'div',
          null,
          '#',
          item.Id
        ), _react2.default.createElement(_reactIntl.FormattedDate, {
          value: item.Created,
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })], _react2.default.createElement(
          'div',
          null,
          (0, _message.getMessage)((0, _get2.default)(item, 'Transactions[0].Status'))
        )];
      } else if (product === 'fantasy') {
        return [[_react2.default.createElement(
          'div',
          null,
          '#',
          item.TournamentId
        ), _this.getFormattedDate(item.Created)], [_react2.default.createElement(_Translate2.default, {
          tag: 'div',
          id: 'label.history.bet',
          defaultMessage: 'Bet: {value}',
          values: {
            value: _react2.default.createElement(_Money2.default, { value: item.Bet + item.Rake, currency: item.Currency })
          }
        }), _react2.default.createElement(_Translate2.default, {
          tag: 'div',
          id: 'label.history.win',
          defaultMessage: 'Win: {value}',
          values: {
            value: _react2.default.createElement(_Money2.default, { value: item.Win, currency: item.Currency })
          }
        })]];
      }

      return [[_react2.default.createElement(
        'div',
        null,
        '#',
        item.Id
      ), _this.getFormattedDate(item.Started)]];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HistoryWidgetList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Initial page of transactions
      this.getTransactions();
    }
  }, {
    key: 'getTransactions',
    value: function getTransactions() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var limit = this.props.limit;

      this.props.getTransactions(limit, page * limit - limit);
    }
  }, {
    key: 'nextPage',
    value: function nextPage() {
      var page = this.state.page;

      var nextPage = page + 1;

      this.getTransactions(nextPage);

      this.setState({
        page: nextPage
      });
    }
  }, {
    key: 'prevPage',
    value: function prevPage() {
      var page = this.state.page;

      var prevPage = page - 1;

      this.getTransactions(prevPage);

      this.setState({
        page: prevPage
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          product = _props.product,
          limit = _props.limit;
      var page = this.state.page;


      var pageItems = items.data;

      var listItems = pageItems.map(function (item) {
        return {
          id: item,
          info: _this2.createListInfo(item, product, items.isLoading),
          detail: _this2.createListDetail(item, product, items.isLoading)
        };
      });

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_List2.default, { data: listItems }),
        _react2.default.createElement(
          'div',
          { className: 'navigation' },
          _react2.default.createElement(
            _Button2.default,
            {
              className: 'button tertiary small prev ' + (page == 1 && 'disabled'),
              onClick: function onClick() {
                return page > 1 && _this2.prevPage();
              } },
            _react2.default.createElement(_Translate2.default, {
              id: 'action.history.prev-page',
              defaultMessage: 'Prev page'
            })
          ),
          _react2.default.createElement(
            _Button2.default,
            {
              className: 'button tertiary small next ' + (listItems.length < limit && 'disabled'),
              onClick: function onClick() {
                return listItems.length >= limit && _this2.nextPage();
              } },
            _react2.default.createElement(_Translate2.default, {
              id: 'action.history.next-page',
              defaultMessage: 'Next page'
            })
          )
        )
      );
    }
  }]);

  return HistoryWidgetList;
}(_react2.default.Component);

var HistoryWidget = function HistoryWidget(_ref2) {
  var getTransactions = _ref2.getTransactions,
      items = _ref2.items,
      products = _ref2.products,
      limit = _ref2.limit,
      currency = _ref2.currency;

  var accordionItems = products.map(function (product) {
    return {
      header: (0, _message.getMessage)(product),
      content: _react2.default.createElement(HistoryWidgetList, {
        product: product,
        currency: currency,
        limit: limit,
        getTransactions: getTransactions[product],
        items: items[product]
      })
    };
  });

  return _react2.default.createElement(_AccordionWidget2.default, { items: accordionItems });
};

HistoryWidget.propTypes = {
  getTransactions: _propTypes2.default.arrayOf(_propTypes2.default.func).isRequired,
  products: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  items: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.shape({
    /** The clickable item header */
    header: _propTypes2.default.string.isRequired,

    /** The click handler to override default behaviour */
    onClickHeader: _propTypes2.default.function,

    /** The expandable content/component */
    content: _propTypes2.default.element
  }))).isRequired,
  currency: _propTypes2.default.string.isRequired,
  limit: _propTypes2.default.number
};

exports.default = HistoryWidget;